export interface TabDef<K extends string> {
  key: K
  label: string
}

// Underline tab bar (the Trades look): neutral active underline, full-width
// white strip with bottom border. Shared across Trades + thesis detail.
export function Tabs<K extends string>({
  tabs,
  active,
  onChange,
}: {
  tabs: TabDef<K>[]
  active: K
  onChange: (key: K) => void
}) {
  return (
    <nav className="flex w-full border-b border-gray-200 bg-white">
      {tabs.map((t) => {
        const selected = t.key === active
        return (
          <button
            key={t.key}
            onClick={() => onChange(t.key)}
            className={`-mb-px border-b-2 px-4 py-2 text-xs font-medium ${
              selected ? 'border-slate-500 text-slate-800' : 'border-transparent text-gray-500 hover:text-gray-800'
            }`}
          >
            {t.label}
          </button>
        )
      })}
    </nav>
  )
}
